"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides the UI for a page-level container of action views. Only a single instance of this view is intended to be used for an application. Instances of this view are intended to be "managed" by the backbone layout manager library.
 * @module app/views/ActionContainerView
 */
var Page_1 = require("../../core/Page");
var React = require("react");
var ActionView_1 = require("../../core/views/ActionView");
require("backbone.layoutmanager");
require("bootstrap");
var $ = require("jquery");
var ActionContainerView = /** @class */ (function (_super) {
    __extends(ActionContainerView, _super);
    function ActionContainerView(props) {
        return _super.call(this, props) || this;
    }
    ActionContainerView.prototype.componentDidMount = function () {
        var refs = this.refs;
        var $wrapper = $(refs.wrapper);
        if ($.fn.affix) {
            $wrapper.affix({
                offset: {
                    top: Page_1.default.getPageHeaderHeight(),
                },
                target: $(".scroll-container"),
            });
        }
    };
    ActionContainerView.prototype.render = function () {
        return (React.createElement("div", { className: "row action-wrapper", ref: "wrapper" },
            React.createElement("div", { className: "actions col-sm-6 left-actions pull-left" }, this.props.left.map(function (actionViewProps) {
                return (React.createElement(ActionView_1.default, __assign({ key: actionViewProps.itemKey() }, actionViewProps)));
            })),
            React.createElement("div", { className: "actions col-sm-6 right-actions pull-right" }, this.props.right.map(function (actionViewProps) {
                return (React.createElement(ActionView_1.default, __assign({ key: actionViewProps.itemKey() }, actionViewProps)));
            }))));
    };
    return ActionContainerView;
}(React.Component));
exports.default = ActionContainerView;
//# sourceMappingURL=ActionContainerView.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/ActionContainerView.js
// module id = 671
// module chunks = 1